import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  Button,
  Box,
  Typography,
  Tooltip,
} from "@mui/material";

import CalendarPopup from "../../../src/assests/images/CalendarPopup.svg";
import closeIcon from "../../../src/assests/images/close-circle.svg";
import { cohortassign, cohortassign2, scheduleAssign, scheduleAssignfinal } from "../../pages/tasks-assigning/api";
import { getToken } from "../../utils/utils";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import DropDownFilter from "../../pages/reports/RetailerAll/DropDownFilter";
import DatePickersCohort from "./DatepickerCohort";
import { AxiosError } from "axios";

const token = getToken();

export interface Option {
  label: string;
  value: string;
  disabled?: boolean;
}

interface Task {
  id: string;
  name: string;
  points?: string; // Made optional to resolve type mismatch
}
interface TaskData { task_name: string; credit_points: string; durations: string; }
const ScheduledTask = ({
  endDate1,                // 👈 add
  setEndDate1,
  endDate2,                // 👈 add
  setEndDate2,
  open,
  onClose,
  task_id,
  user_ids,
  date,
  time,
  cohortIds,
  cohorttaskid,
  value,
  selectedDate1,
  setSelectedDate1,
  selectedTime,
  setSelectedTime,
  selected,
  unselectedIds,
  checkbaledata,
  missingidssssss,
  tasks,
  setTasks,
  buttonpresent,
  handleCombinedAssignClick1,
  selectedTasks1,
  setSelectedTasks1,
  selectedRows, setSelectedRows,
  gettaskdata, setGetTaskData ,
  assignedCount,
  selectedCohortStatuses,
  setSelectedCohortStatuses,
   selectedTaskIds,        // ✅ new prop
  setSelectedTaskIds, 
  userdatadata  ,
    totalCreditPoints,
  setTotalCreditPoints,
  totalRetailers,
  setTotalRetailers

}: {
  selectedTasks1: string[];
   assignedCount: number;
  setSelectedTasks1: React.Dispatch<React.SetStateAction<string[]>>;
  endDate1: Date | null;                               // 👈 NEW
  setEndDate1: Dispatch<SetStateAction<Date | null>>;
  endDate2: Date | null;                               // 👈 NEW
  setEndDate2: Dispatch<SetStateAction<Date | null>>;
  open: boolean;
  buttonpresent: boolean
  onClose: () => void;
  handleCombinedAssignClick1: () => void;
  task_id: string;
  user_ids: string[];
  cohorttaskid: string;
  date: string;
  time: string;
  cohortIds: string[];
  selected: number[];
  unselectedIds: number[];
  tasks: Task[];
  setTasks: React.Dispatch<React.SetStateAction<Task[]>>;
  missingidssssss: number[];
  checkbaledata: any[];
  value: string;
  selectedDate1: Date | null;
  setSelectedDate1: Dispatch<SetStateAction<Date | null>>;
  selectedTime: string | null;
  setSelectedTime: Dispatch<SetStateAction<string | null>>;

   selectedRows: number[];
  setSelectedRows: React.Dispatch<React.SetStateAction<number[]>>;
   gettaskdata: TaskData | null;
  setGetTaskData: React.Dispatch<React.SetStateAction<TaskData | null>>;
   selectedCohortStatuses: Record<string, string>;
  setSelectedCohortStatuses: React.Dispatch<React.SetStateAction<Record<string, string>>>;
    selectedTaskIds: string[];
  setSelectedTaskIds: React.Dispatch<React.SetStateAction<string[]>>;
  userdatadata:string
   totalCreditPoints: number;
  setTotalCreditPoints: React.Dispatch<React.SetStateAction<number>>;
  totalRetailers: number;
  setTotalRetailers: React.Dispatch<React.SetStateAction<number>>;

}) => {
  const [selectedDate, setselectedDate] = useState<string | null>(null);
  const [selecttime, setselectedtime] = useState<string | null>(null);
  const [selectedTasks, setSelectedTasks] = useState<string[]>([]);
  const [totalBudget, setTotalBudget] = useState(0); // Separate useState for total points/budget

  const [endDate, setEndDate] = useState<Date | null>(null);

  const { id } = useParams();
  const { cohort_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const [totalcountoutletsh, settotalcountoultes] = useState([]);

  const isCohortView = location.pathname.replace(/\/$/, "") === "/cohorts-view" && !buttonpresent || location.pathname.replace(/\/$/, "") !== "/cohorts-view" && !buttonpresent;
console.log(selectedCohortStatuses, "selectedCohortStatusesselectedCohortStatuses")
  useEffect(() => {
    if (location.state?.valuetabsdatapagelengthselectedRows) {
      settotalcountoultes(location.state.valuetabsdatapagelengthselectedRows);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.selectedDateassigntask) {
      setselectedDate(location.state.selectedDateassigntask);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.selectedTimeasiigntask) {
      setselectedtime(location.state.selectedTimeasiigntask);
    }
  }, [location.state]);

  // Calculate total budget when selected tasks change
  console.log(cohortIds.length, "55555555555555555")
  useEffect(() => {
    let points = 0;

    // Handle multiple selected tasks (combine selectedTasks and selectedTasks1 if needed)
    const allSelectedTaskIds = Array.from(new Set([...selectedTasks, ...selectedTasks1])); // Dedupe if overlap

    if (allSelectedTaskIds.length > 0) {
      points = allSelectedTaskIds.reduce((acc, taskId) => {
        const task = tasks.find((t) => t.id === taskId);
        return acc + (task ? Number(task.points || '0') : 0);
      }, 0);
    } else if (gettaskdata?.credit_points) {
      // Fallback to single task data if no tasks selected
      points = Number(gettaskdata.credit_points);
    }

    // Multiplier based on context (selectedRows or cohortIds)
    const multiplier = id ? selectedRows.length : totalRetailers;
    setTotalBudget(points * (multiplier || 1)); // Ensure multiplier is at least 1 to avoid 0
    console.log(points, "pointspointspointspoints")
  }, [selectedTasks, selectedTasks1, tasks, gettaskdata, selectedRows, totalRetailers, id]);
console.log(totalRetailers, "totalRetailerstotalRetailerstotalRetailers",totalCreditPoints)
  // const formattedDate = selectedDate1 ? selectedDate1.toLocaleDateString("en-GB") : "";
  
  // const formattedTime = selectedDate1
  //   ? selectedDate1.toLocaleTimeString("en-US", {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   })
  //   : "";


    const formattedDate = selectedDate1?selectedDate1.toLocaleDateString("en-GB"):""// → "25/09/2025"

// Format time as HH:mm (24-hour)
const formattedTime = selectedDate1?selectedDate1.toLocaleTimeString("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
}):""; // → "13:12"

    console.log(formattedTime, "formattedTimeppppppppppppppp",selectedDate1)
  const formattedEndDate = endDate ? endDate.toLocaleDateString("en-GB") : "";
  // const formattedEndTime = endDate
  //   ? endDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
  //   : "";

    const formattedEndTime = endDate?endDate.toLocaleTimeString("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
}):""; 
const handleScheduleAssign = async () => {
  if (Number(value) === 2) {
    showAlert("Assigning task...", "success");
    try {
      const response = await scheduleAssign(
        token,
        String(id),
        selectedRows,
        formattedDate,
        formattedTime,
        formattedEndDate,
        formattedEndTime
      );
      if (response.data.success) {
        showAlert("Task scheduled successfully!", "success");
        // navigate(`/assign-task/${id}`);
        // setTimeout(() => window.location.reload(), 100);
      }
      setSelectedTime(null);
      setSelectedDate1(null);
      setEndDate(null);
      setEndDate1(null);
      setEndDate2(null);
      onClose();
    } catch (error) {
      let errorMessage = "An error occurred while assigning the task";
      if (error instanceof AxiosError) {
        // Axios error detected
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message;
      } else if (error instanceof Error) {
        // Fallback for normal JS errors
        errorMessage = error.message;
      }

      console.error("Error assigning task:", error);
      showAlert(errorMessage, "error");
    }
  } else {
    showAlert("Invalid value for task assignment", "error");
  }
};

  //     console.error("Invalid value for scheduling");
  //     showAlert("An error occurred while assigning the task", "error");
  //   }
  // };

  const handleScheduleAssign122 = async () => {
    if (Number(value) === 1 && !buttonpresent) {
      showAlert("Assigning task...", "success");
      console.log("oooooooooooooooooooo")
      try {
        const response = await cohortassign2(
          token,
          String(selectedTasks),
          cohortIds,
          formattedDate,
          formattedTime,
          formattedEndDate,
          formattedEndTime
        );
        if (response.data.success) {
          showAlert("Task scheduled successfully!", "success");
          // navigate(`/cohorts-view`);
          // setTimeout(() => window.location.reload(), 100);
        }
        setSelectedTime(null);
        setSelectedDate1(null);
        setEndDate(null);
        setEndDate1(null);
        setEndDate2(null);
        onClose();
      } catch (error) {
        console.error("Error assigning task:", error);
        showAlert("An error occurred while assigning the task", "error");
      let errorMessage = "An error occurred while assigning the task";
      if (error instanceof AxiosError) {
        // Axios error detected
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message;
      } else if (error instanceof Error) {
        // Fallback for normal JS errors
        errorMessage = error.message;
      }

      console.error("Error assigning task:", error);
      showAlert(errorMessage, "error");
    }
  } else {
    showAlert("Invalid value for task assignment", "error");
  }
};

  const handleScheduleAssigncohorttaskids = async () => {
    if (isCohortView) {
      if (selectedTasks.length === 0) {
        showAlert("Please select at least one task!", "warning");
        return;
      }
      showAlert("Assigning task...", "success");
      try {
        const response = await cohortassign2(
          token,
          String(selectedTasks),
          cohortIds,
          formattedDate,
          formattedTime,
          formattedEndDate,
          formattedEndTime
        );
        if (response.data.success) {
          showAlert("Task assigned successfully!", "success");
          // navigate(`/cohorts-view`);
          // setTimeout(() => window.location.reload(), 100);
        }
        setSelectedTime(null);
        setSelectedDate1(null);
        setEndDate(null);
        setEndDate1(null);
        setEndDate2(null);
        setSelectedTasks([]);
        setSelectedTasks1([]);
        onClose();
      } catch (error) {
        console.error("Error assigning task:", error);
         let errorMessage = "An error occurred while assigning the task";
      if (error instanceof AxiosError) {
        // Axios error detected
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message;
      } else if (error instanceof Error) {
        // Fallback for normal JS errors
        errorMessage = error.message;
      }

      console.error("Error assigning task:", error);
      showAlert(errorMessage, "error");
    }
  } else {
    showAlert("Invalid value for task assignment", "error");
  }
};
  const handleScheduleAssigncohort = async () => {
    if (Number(cohort_id)) {
      showAlert("Assigning task...", "success");
      try {
        const response = await scheduleAssignfinal(
          token,
          cohorttaskid,
          missingidssssss,
          formattedDate,
          formattedTime,
          formattedEndDate,
          formattedEndTime,
          Number(cohort_id)
        );
        if (response.data.success) {
          showAlert("Task assigned successfully!", "success");
          navigate(`/assign-task/${id}`);
          setTimeout(() => window.location.reload(), 100);
        }
        setSelectedTime(null);
        setSelectedDate1(null);
        setEndDate(null);
        setEndDate1(null);
        setEndDate2(null);
        onClose();
      } 
        catch (error) {
        console.error("Error assigning task:", error);
         let errorMessage = "An error occurred while assigning the task";
      if (error instanceof AxiosError) {
        // Axios error detected
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message;
      } else if (error instanceof Error) {
        // Fallback for normal JS errors
        errorMessage = error.message;
      }

      console.error("Error assigning task:", error);
      showAlert(errorMessage, "error");
    }
  } else {
    showAlert("Invalid value for task assignment", "error");
  }
};
  console.log(value, buttonpresent, "buttonpresentbuttonpresent")
  const handleCombinedAssignClick = async () => {
    try {

      if (Number(cohort_id)) {
        await handleScheduleAssigncohort();
      } else if (Number(value) === 2) {
        await handleScheduleAssign();
      } else if (Number(value) === 1 && !buttonpresent) {
        console.log("kkkkkkkkkk")
        await handleScheduleAssign122();
      } else if (isCohortView) {
        await handleScheduleAssigncohorttaskids();
      } else {
        console.log(value, buttonpresent, "chchchchhcc")
        console.error("Invalid value provided for scheduling");
        showAlert("Invalid value provided for scheduling", "error");
      }
    } catch (error) {
      
        console.error("Error assigning task:", error);
         let errorMessage = "An error occurred while assigning the task";
      if (error instanceof AxiosError) {
        // Axios error detected
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message;
      } else if (error instanceof Error) {
        // Fallback for normal JS errors
        errorMessage = error.message;
      }

      console.error("Error assigning task:", error);
      showAlert(errorMessage, "error");
    }
  }
const anyTrue = Object.values(selectedCohortStatuses).some(
  status => typeof status === "boolean" && status === true
);

// Render dropdown only if no true exists or object is empty
const values = Object.values(selectedCohortStatuses);

// Check if any value is "unknown"
const hasUnknown = values.some(status => status === "unknown");

// ✅ Show dropdown only if "unknown" exists
const shouldRenderDropdown = hasUnknown;
  const handleTaskSelection = (next: string[]) => {
    setSelectedTasks(next);
  };

  const handleTaskSelection1 = (next: string[]) => {
    setSelectedTasks1(next);
  };


  const taskOptions: Option[] = tasks.map((task) => ({
    label: task.name,
    value: task.id,
  }));
useEffect(() => {
  setSelectedTasks(selectedTaskIds || []);
}, [selectedTaskIds]);
  console.log(isCohortView, "isCohortViewisCohortView", buttonpresent)
  console.log(selectedTasks, "selectedTasksselectedTasks",selectedTaskIds)
console.log(selectedDate1,"dfdsfdsfselectedDate1")
console.log(selectedRows.length, "selectedRows4444",gettaskdata?.credit_points)
console.log(cohortIds, "cohortIds4444444444444",selectedCohortStatuses,shouldRenderDropdown)
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          overflowY: "inherit",
          borderRadius: "10px",
        },
      }}
    >
      <DialogTitle
        sx={{
          width: "450px",
          borderRadius: "20px",
          padding: "0",
          height: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #d7d4d4",
            padding: "10px 20px",
          }}
        >
          <Box >
            <Typography sx={{ display: "flex" }}>
              <img src={CalendarPopup} alt="Create Cohort" />
              <Typography
                sx={{
                  marginLeft: "10px",
                  marginTop: "10px",
                  fontWeight: "600",
                }}

              >
                {isCohortView ? "Schedule Task" : "Assign Task"}
                <Typography sx={{ color: "#7D7E7F", fontSize: "14px" }}>
                  {isCohortView
                    ? "Fill the data below to schedule task"
                    : "Fill the data below to assign task"}
                </Typography>
              </Typography>
            </Typography>
          </Box>
          <Box>
            <Button
              onClick={onClose}
              color="primary"
              sx={{
                borderRadius: "50%",
                color: "#000",
                fontSize: "10px",
                position: "relative",
                right: "-20px",
                background: "#fff",
                marginTop: "-23px",
              }}
            >
              <img src={closeIcon} alt="close" />
            </Button>
          </Box>
        </Box>

        <Box sx={{ padding: "0 20px 20px" }}>
          {isCohortView && (
            <Box sx={{ width: "100%" }}>
                   {/* {assignedCount === 0 && ( */}
               <Typography
                variant="subtitle2"
                sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
              >
              Total Budget: {totalBudget}
              </Typography>
                    {/* )} */}
              <Typography
                variant="subtitle2"
                sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
              >
                Start Date
              </Typography>
              <Box sx={{ position: "relative" }}>
                <DatePickersCohort
                  setSelectedDate1={setSelectedDate1}
                  selectedDate1={selectedDate1}
                />
              </Box>
            </Box>
          )}

          {buttonpresent && location.pathname.replace(/\/$/, "") === "/cohorts-view" ? (
            <>
              <Box sx={{ width: "100%" }}>
                  <Typography
                variant="subtitle2"
                sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
              >
              Total Budget: {totalCreditPoints}
              </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
                >
                  End Date
                </Typography>
                <Box sx={{ position: "relative" }}>
                  <DatePickersCohort
                    setSelectedDate1={setEndDate2}
                    selectedDate1={endDate2}
                  />
                </Box>
              </Box>
{/* selectedCohortStatuses!==true */}
{shouldRenderDropdown && (
              <Box
                sx={{
                  minWidth: 150,
                  width: "398px",
                  color: "#DEDEDE",
                  background: "#fff !important",
                  height: "56px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  justifyContent: "center",
                  backgroundColor: "#FFF",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ mt: 2, color: "#282829", fontSize: "16px", mb: 1 }}
                >
                  Select Tasks
                </Typography>
                <DropDownFilter
                  placeholder="Select Tasks"
                  options={taskOptions}
                  value={selectedTasks1}
                  onChange={handleTaskSelection1}
                  maxMenuHeight={300}
                  showSelectAll={true} tabKey={""} />
              </Box>
              )}
            </>
          ) : buttonpresent && id ? (
            <Box sx={{ width: "100%" }}>
                {/* {assignedCount === 0 && ( */}
               <Typography
                variant="subtitle2"
                sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
              >
              Total Budget: {totalBudget}
              </Typography>
                    {/* )} */}
              <Typography
                variant="subtitle2"
                sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
              >
                End Date
              </Typography>
              <Box sx={{ position: "relative" }}>
                <DatePickersCohort
                  setSelectedDate1={setEndDate1}
                  selectedDate1={endDate1}
                />
              </Box>
        
            </Box>
          ) : (
            <Box sx={{ width: "100%" }}>
              <Typography
                variant="subtitle2"
                sx={{ mt: 2, color: "#282829", fontSize: "16px" }}
              >
                End Date
              </Typography>
              <Box sx={{ position: "relative" }}>
                <DatePickersCohort
                  setSelectedDate1={setEndDate}
                  selectedDate1={endDate}
                />
              </Box>
            </Box>
          )}



          {isCohortView && location.pathname.replace(/\/$/, "") === "/cohorts-view" && (
            <Box
              sx={{
                minWidth: 150,
                width: "398px",
                color: "#DEDEDE",
                background: "#fff !important",
                height: "56px",
                borderRadius: "8px",
                fontWeight: "500",
                justifyContent: "center",
                backgroundColor: "#FFF",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{ mt: 2, color: "#282829", fontSize: "16px", mb: 1 }}
              >
                Select Tasks
              </Typography>
              <DropDownFilter
                placeholder="Select Tasks"
                options={taskOptions}
                value={selectedTasks}
                onChange={handleTaskSelection}
                maxMenuHeight={300}
                showSelectAll={true} tabKey={""} />
            </Box>
          )}

          <Box
            sx={{
              marginTop: "50px",
              display: "flex",
              justifyContent: "flex-end",
              position: "relative",
            }}
          >
            <Tooltip title="Cancel" arrow>
              <Button
                onClick={onClose}
                color="primary"
                sx={{
                  border: "1px solid #C8172F",
                  color: "#C8172F",
                  width: "112px",
                  padding: "10px 0",
                  borderRadius: "10px",
                  marginRight: "10px",
                }}
              >
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title={isCohortView ? "Schedule Assign" : "Assign Task"} arrow>
              <Button
                sx={{
                  background: "#C8172F",
                  color: "#fff",
                  textTransform: "capitalize",
                  marginLeft: "10px",
                  padding: "8px 20px",
                  borderRadius: "10px",
                  alignItems: "center",
                }}
                onClick={isCohortView ? handleCombinedAssignClick : handleCombinedAssignClick1}


              >
                {isCohortView ? "Schedule Assign" : "Assign Task"}
              </Button>
            </Tooltip>
          </Box>
        </Box>
      </DialogTitle>
    </Dialog>
  );
};

export default ScheduledTask;